import { IGlobalRegion } from "components/GlobalContext";
import { Table } from "react-bootstrap";
import { formatDateTime } from "./StringUtility";
import parse from 'html-react-parser';
import { ILogEntry } from "models/ILogEntry";
import { IFileAttachment } from "models/IFileAttachment";

export type SiteEnvironment = "dev" | "qa" | "prod";

export const getEnvironment = (): SiteEnvironment => {
    if (window.location.toString().toLocaleLowerCase().indexOf("tfthealth.com") > -1) {
        return "prod";
    }
    else if (window.location.toString().toLocaleLowerCase().indexOf("localhost") > -1) {
        return "dev";
    }
    else {
        return "qa";
    }
};

export const getBaseDomain = () => {
    if (window.location.toString().toLocaleLowerCase().indexOf("tfthealth.com") > -1) {
        return "www.tfthealth.com";
    }
    else if (window.location.toString().toLocaleLowerCase().indexOf("localhost") > -1) {
        return "localhost:3000";
    }
    else {
        return "dpsappqa.azurewebsites.net"
    }
};

export const rotateImage = (imageBase64: any, rotation: number, cb: Function) => {
    var img = new Image();
    img.src = imageBase64;
    img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        if (ctx) {
            ctx.setTransform(1, 0, 0, 1, img.width / 2, img.height / 2);
            ctx.rotate(rotation * (Math.PI / 180));
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            cb(canvas.toDataURL("image/jpeg"))
        }
    };
};

export const getCSSEnvironment = () =>
    window.location.toString().indexOf("localhost") > -1 ?
        "DEV" :
        window.location.toString().indexOf("dpsappqa.azurewebsites.net") > -1 ?
            "QA" :
            "";

export const applyGlobalFilterData = (statePropertyName: string, countryPropertyName: string, filter: any, region?: IGlobalRegion, organizationType?: string): any => {
    let returnFilter = structuredClone(filter);

    if (region != null && statePropertyName) {
        if (!filter.hasOwnProperty(statePropertyName) || !filter[statePropertyName] || filter[statePropertyName].length < 1) {
            returnFilter[statePropertyName] = [region.states.join(" ")];
        }
    }

    if (region != null && countryPropertyName) {
        if (!filter.hasOwnProperty(countryPropertyName) || !filter[countryPropertyName] || filter[countryPropertyName].length < 1) {
            returnFilter[countryPropertyName] = [region.countries.join(" ")];
        }
    }

    if (organizationType != null) {
        if (!filter.hasOwnProperty("organizationType") || !filter["organizationType"] || filter["organizationType"].length < 1) {
            returnFilter["organizationTypes"] = [organizationType];
        }
    }

    return returnFilter;
}

export const generateLog = <T extends { systemDataJson?: string; },>(entry: T) => {
    if (!entry.systemDataJson) {
        entry.systemDataJson = "{}";
    }

    const parsedSystemData = JSON.parse(entry.systemDataJson);
    let logMessages: ILogEntry[] = parsedSystemData?.logMessages || [];

    return (
        <>
            {
                logMessages.length < 1 &&
                <h2>No log data</ h2 >
            }
            {
                logMessages.length > 0 &&
                <Table striped bordered hover size="sm" >
                    <thead>
                        <tr>
                            <td>Time / User </td>
                            <td> Event </td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            logMessages.map(
                                (messageData, index) =>
                                    <tr>
                                        <td>
                                            {formatDateTime(messageData.time)} <br />
                                            {messageData.user}
                                        </td>
                                        <td>
                                            {parse(messageData.message)}
                                        </td>
                                    </tr>
                            )
                        }
                    </tbody>
                </Table>
            }
        </>
    )
}

export const addNewLogEntry = <T extends { systemDataJson?: string; },>(time: Date, message: string, user: string, type: number, entry: T) => {
    const updateEntry: T = { ...entry };

    if (!updateEntry.systemDataJson) {
        updateEntry.systemDataJson = "{}";
    }

    const parsedSystemData = JSON.parse(updateEntry.systemDataJson);
    let logMessages: ILogEntry[] = parsedSystemData?.logMessages || [];
    logMessages.push({ time, message, user, type });
    updateEntry.systemDataJson = JSON.stringify({ ...parsedSystemData, ...{ logMessages } });
    console.log("Adding log entry " + JSON.stringify(logMessages.at(-1)));
    return updateEntry;
};

export const addNewFileAttachment = <T extends { systemDataJson?: string; },>(time: Date, fileName: string, user: string, title: string, entry: T) => {
    const updateEntry: T = { ...entry };

    if (!updateEntry.systemDataJson) {
        updateEntry.systemDataJson = "{}";
    }

    const parsedSystemData = JSON.parse(updateEntry.systemDataJson);
    let files: IFileAttachment[] = parsedSystemData?.files || [];
    files.push({ time, title, user, fileName });
    updateEntry.systemDataJson = JSON.stringify({ ...parsedSystemData, ...{ files } });
    return updateEntry;
};